// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"cb7e4163","422":"1ba900fa","699":"fef0a79b","726":"dbfc1573","756":"ab00d785","914":"dc56983c","961":"c889d89e"}[chunkId] + ".chunk.js";
};